import { GetDefaultThemeUseCase } from '@/data/use-cases/theme-use-cases.js';
import { UpdateDefaultThemeUseCase } from '@/data/use-cases/theme-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { ThemeRepositoryImpl } from '@/infra/repositories/theme-repository-impl.js';
import { ThemeController } from '@/presentation/controllers/theme-controller.js';

export const makeThemeController = (httpClient: FetchHttpClient): ThemeController => {
    const repository = new ThemeRepositoryImpl(httpClient);
    return new ThemeController(new GetDefaultThemeUseCase(repository), new UpdateDefaultThemeUseCase(repository));
};
